import WebsiteDetail from './WebsiteDetail';

export default WebsiteDetail;



// WEBPACK FOOTER //
// ./src/components/admin/Website/index.js